import React from "react"
import ReactDOM from "react-dom/client"

import App from "./App"
import reportWebVitals from "./reportWebVitals"

/* CSS */
import "./design/css/app.css"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<App />)

reportWebVitals()
